export default{
    
    lista:{
        method:'get',
        url:'folhar/evento1200/lista'
    },
    cadastra:{
        method:'post',
        url:'folhar/evento1200/cadastro'
    },
    update1200:{
        method:'put',
        url:'folhar/evento1200/update'
    },
    delete1200:{
        method:'delete',
        url:'folhar/evento1200/deletar{/id}'
    },
    cadastra1210:{
        method:'post',
        url:'folhar/evento1210/cadastro'
    },
    update1210:{
        method:'put',
        url:'folhar/evento1210/update'
    },
    delete1210:{
        method:'delete',
        url:'folhar/evento1210/deletar{/id}'
    },
    delete:{
        method:'delete',
        url:'basecalculo/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'folhar/evento1200/editar{/id}'
    },
    update:{
        method:'put',
        url:'evento/update'
    },
    inss:{
        method:'get',
        url:'folhar/evento1200/busca{/id}'
    },
}